import React, { Component } from 'react'
import RegisterForm from '../register/form.js'

export default class Register extends Component {
  constructor () {
    super()

    this.state = {
      pcd: 'false'
    }
  }

  onChangeInput = (value, name) => {
    this.setState({
      [name]: value
    })
  }

  onRegisterClick = () => {
    fetch('fake-endpoint/', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state)
    })
  }

  setAddress = (values) => {
    this.setState({
      cep: values.cep,
      address: values.logradouro,
      district: values.bairro,
      city: values.localidade,
      state: values.uf
    })
  }

  render() {
    return (
      <div id="register-page" className="clear relative">
        <section className="squad">
          <h2>
            CADASTRE-SE
            <span>preencha os campos logo abaixo</span>
          </h2>

          <RegisterForm
            values={this.state}
            onChangeInput={this.onChangeInput}
            setAddress={this.setAddress}
            onRegisterClick={this.onRegisterClick}/>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/register/register.js